<template>
  <div
    class="w-[11rem] inline-flex items-center cursor-pointer select-none rounded-t p-1.5 relative border-l border-t last:border-r shadow"
    :class="{
     'text-sm text-white bg-primary border-primary p-1': active,
      'text-xs hover:text-primary': !active
    }"
		style="transition: all 0.2s;will-change: font-size, color;"
	>
    <span
			:id="id"
      class="window-tab truncate font-medium tracking-tighter"
      :class="[
				pinned ? 'italic' : '',
				$attrs.class
			]"
			v-tooltip="{
				content: title,
				disabled: !isTruncated
			}"
    >
      {{ title }}
    </span>
		<AppIcon
			icon="fa-regular fa-close"
			class="window-tab-close cursor-pointer p-1 ml-auto rounded"
			:class="{
        'hover:bg-black/10': active,
        'hover:bg-gray-100 hover:text-primary': !active
      }"
			@click.stop="$emit('close')"
		/>
	</div>
</template>

<script setup lang="ts">
const props = defineProps<{
	title: string;
	pinned?: boolean;
	active?: boolean;
}>();

const id = Math.random().toString(36);
const isTruncated = ref<boolean>(true);

onMounted(() => {
	const element = document.getElementById(id);
	isTruncated.value = (element?.scrollWidth ?? 0) > (element?.clientWidth ?? 0);
});

const { title, pinned, active } = toRefs(props);
defineEmits<{
	(e: "close"): void;
}>();
</script>

<style scoped></style>
